import { render, staticRenderFns } from "./Shitang2.vue?vue&type=template&id=1e35dae2&scoped=true"
import script from "./Shitang2.vue?vue&type=script&lang=js"
export * from "./Shitang2.vue?vue&type=script&lang=js"
import style0 from "./Shitang2.vue?vue&type=style&index=0&id=1e35dae2&prod&scoped=cabteeb&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35dae2",
  null
  
)

export default component.exports